import React from "react";
import EmployeesHero from "../components/employeescomponents/EmployeesHero";

const EmployeesPage = () => {
  return (
    <div>
      <EmployeesHero />
    </div>
  );
};

export default EmployeesPage;
